function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n          position: absolute;\n          top: 40%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n          border-radius: 4px;\n          background-color: white;\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n            float: right;\n          "
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n            padding: ",
        ";\n          "
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { css } from "@emotion/react";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Typography, useTheme } from "@mui/material";
import DefaultModal from "@mui/material/Modal";
var Modal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, children = param.children, title = param.title;
    var theme = useTheme();
    return /*#__PURE__*/ _jsx(DefaultModal, {
        open: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ _jsxs("div", {
            css: css(_templateObject()),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    css: css(_templateObject1()),
                    children: /*#__PURE__*/ _jsx(IconButton, {
                        onClick: onClose,
                        children: /*#__PURE__*/ _jsx(CloseIcon, {})
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    css: css(_templateObject2(), theme.spacing(2, 4, 3)),
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "h6",
                            align: "center",
                            children: title
                        }),
                        children
                    ]
                })
            ]
        })
    });
};
export default Modal;
